'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var index = require('../../providers/ClaimBuilder/index.js');
var SessionContext = require('../../providers/SessionContext.js');
var useAnalytics = require('../../providers/useAnalytics.js');
var useTitanAnalytics = require('../../providers/titan/useTitanAnalytics.js');
var PackageAdditionalInfoProvider = require('./PackageAdditionalInfoProvider.js');
var nthHookTranslations = require('@narvar/nth-hook-translations');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const PackageAdditionalInfo = _ref => {
  let {
    children
  } = _ref;
  const {
    state: {
      claimType
    }
  } = index.useClaimBuilder();
  const titan = useTitanAnalytics["default"]();
  const logEvent = useAnalytics["default"]();
  const {
    orderNumber
  } = SessionContext.useSession();
  const {
    packageClaimStep,
    packageDetails,
    claimDetails
  } = PackageAdditionalInfoProvider.usePackageAdditionalInfo();
  React.useEffect(() => {
    var _packageDetails$edd;
    // Note: This effect is only called on first component render
    const claimSteps = claimDetails.claimSteps.map(claimStep => claimStep.id) ?? [];
    titan === null || titan === void 0 ? void 0 : titan.batch({
      batch: [{
        type: 'page',
        name: 'Package Additional Info'
      }, {
        type: 'track',
        event: 'product_viewed',
        properties: {
          product_id: packageDetails.trackingNumber,
          sku: packageDetails.items.map(item => item.sku).join(','),
          name: (_packageDetails$edd = packageDetails.edd) === null || _packageDetails$edd === void 0 ? void 0 : _packageDetails$edd.begin,
          brand: packageDetails.status,
          variant: packageDetails.statusCode,
          extra_properties: [{
            key: 'claim_steps',
            value: claimSteps.join(',')
          }, {
            key: 'current_claim_step',
            value: packageClaimStep.id
          }]
        }
      }]
    })
    // eslint-disable-next-line no-console
    .catch(e => console.error(e));
    logEvent({
      event_type: useAnalytics.ClaimsEventTypes.PAGE_LOAD,
      event_component: useAnalytics.ClaimsEventComponents.NTH_KIT_CLAIMS_SHIPMENT_ADDITIONAL_INFO,
      page_step: useAnalytics.ClaimsPageStep.SELECTION_COMMENT,
      order_number: orderNumber,
      claim_reason: claimType
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, children);
};
const PackageAdditionalInfoGuarded = _ref2 => {
  var _currentPackageClaim$;
  let {
    children
  } = _ref2;
  const {
    state: {
      currentPackageDetails,
      currentPackageClaim
    },
    handleInvalidData
  } = index.useClaimBuilder();
  const {
    claimsAdditionalInfoCommentsHelperTextOptionalPackageMissing,
    claimsAdditionalInfoCommentsHelperTextRequiredPackageMissing,
    claimsAdditionalInfoConfirmationLabelPackageMissing,
    claimsAdditionalInfoCommentsLabelPackageMissing
  } = nthHookTranslations.useTranslations();
  if ((currentPackageClaim === null || currentPackageClaim === void 0 ? void 0 : (_currentPackageClaim$ = currentPackageClaim.currentClaimStep) === null || _currentPackageClaim$ === void 0 ? void 0 : _currentPackageClaim$.id) !== index.ClaimStepId.ADDITIONAL_INFO || !currentPackageDetails) {
    handleInvalidData();
    return null;
  }
  return /*#__PURE__*/React__default["default"].createElement(PackageAdditionalInfoProvider.PackageAdditionalInfoProvider, {
    value: {
      currentPackageDetails,
      currentPackageClaim,
      currentClaimStep: currentPackageClaim.currentClaimStep,
      translations: {
        claimsAdditionalInfoCommentsHelperTextOptionalPackageMissing: claimsAdditionalInfoCommentsHelperTextOptionalPackageMissing ?? '',
        claimsAdditionalInfoCommentsHelperTextRequiredPackageMissing: claimsAdditionalInfoCommentsHelperTextRequiredPackageMissing ?? '',
        claimsAdditionalInfoConfirmationLabelPackageMissing: claimsAdditionalInfoConfirmationLabelPackageMissing ?? '',
        claimsAdditionalInfoCommentsLabelPackageMissing: claimsAdditionalInfoCommentsLabelPackageMissing ?? ''
      }
    }
  }, /*#__PURE__*/React__default["default"].createElement(PackageAdditionalInfo, null, children));
};
var PackageAdditionalInfoViewRoot = nthHookTranslations.withTranslationsProvider(PackageAdditionalInfoGuarded, {
  translationKeys: ['claimsAdditionalInfoCommentsHelperTextOptionalPackageMissing', 'claimsAdditionalInfoCommentsHelperTextRequiredPackageMissing', 'claimsAdditionalInfoConfirmationLabelPackageMissing', 'claimsAdditionalInfoCommentsLabelPackageMissing']
});

exports["default"] = PackageAdditionalInfoViewRoot;
